import { firebaseConfig , deepLinkingBaseUrl } from './environment';
import ExtendedAxios from 'helperFunctions/ExtendedAxios';

class Firebase extends ExtendedAxios {

    constructor() {
        super({
            axiosRequestConfig: {
                baseURL: '',
                timeout: 100000,
              },
              defaultParams: {
              },
        });
    }

    generateDeepLink(query: string) {
        // deepLinkBody.deepLink = link;
        const body = {
            dynamicLinkInfo: {
              domainUriPrefix: firebaseConfig.baseUrl,
              link: `${firebaseConfig.domain}?${query}`,
              androidInfo: {
                androidPackageName: firebaseConfig.androidPACKAGEName,
              },
              iosInfo: {
                iosBundleId: firebaseConfig.iosBundleId,
               },
            }
          };
        return this.httpPost(deepLinkingBaseUrl , body);
    }
}
export default new Firebase();
